import React from "react";
import { Column } from "devextreme-react/data-grid";
import { LVGridDetalle } from "../../Componentes/Basicos/LVGridDetalle";

class VEN_Reservas_Detalle extends React.Component {

  constructor(props) {
    super(props);
    this.state = {
      data: [],
      loading: true,
      globalUsaArticulosConPresentacion: true,
      globalUsaArticulosConTamano: true,
      globalUsaArticulosConUnidadDeMedida: true,
    };
  }

  getData = async (IdClave) => {
    // Llama a función asíncrona y maneja los datos
    try {
      const { VEN_Reservas_Cabecera: { function_VEN_Reservas_Cabecera_Leer } } = require('neftis7_apicaller');
      const resultData = await function_VEN_Reservas_Cabecera_Leer(IdClave);
      this.setState({ data: resultData.data, loading: false });
    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
    this.setState({ loading: false });
  };

  getDataParametros = async () => {
    try {
      const { Varios: { TratamientoDeVariableBoolean } } = require('neftis7_apicaller');
      const { Varios: { ObtieneParametros } } = require('neftis7_apicaller');
      const datosModificadores = await ObtieneParametros();
      const globalUsaArticulosConPresentacionLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConPresentacion)
      const globalUsaArticulosConTamanoLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConTamano)
      const globalUsaArticulosConUnidadDeMedidaLocal = await TratamientoDeVariableBoolean(datosModificadores.GlobalUsaArticulosConUnidadDeMedida)

      this.state.globalUsaArticulosConPresentacion = globalUsaArticulosConPresentacionLocal
      this.state.globalUsaArticulosConTamano = globalUsaArticulosConTamanoLocal
      this.state.globalUsaArticulosConUnidadDeMedida = globalUsaArticulosConUnidadDeMedidaLocal

    } catch (error) {
      alert("Error al obtener los datos: " + error);
    }
  };
  
  componentDidMount = async () => {
    this.getData(this.props.data.data.IdReserva)
    this.getDataParametros()
  };

  render() {
    return (
      <React.Fragment>
        {this.state.loadingItems ? null : (
          <>
            {this.state.data && this.state.data.Detalles && this.state.data.Detalles.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.Detalles}
                  Titulo="Items"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />
                  <Column caption="F.Inicio" dataField="FechaReservaInicio" width="150" alignment="Right" dataType="date" format={'dd/MM/yyyy hh:MM:ss'} />

                  <Column caption="Artículo" alignment="Center">
                    <Column caption="Código" dataField="CodigoArticulo" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Articulo" width="100%" alignment="Left" dataType="string" minWidth={100} />
                  </Column>
                  <Column caption="Presentación" alignment="Center" visible={this.state.globalUsaArticulosConPresentacion}>
                    <Column caption="Código" dataField="CodigoPresentacion" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Presentacion" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Tamaño" alignment="Center" visible={this.state.globalUsaArticulosConTamano}>
                    <Column caption="Código" dataField="CodigoTamano" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="Tamano" width="200" alignment="Left" dataType="string" />
                  </Column>
                  <Column caption="Unidad de Medida" alignment="Center" visible={this.state.globalUsaArticulosConUnidadDeMedida}>
                    <Column caption="Código" dataField="CodigoUnidadMedida" width="70" alignment="Left" dataType="string" />
                    <Column caption="Descripción" dataField="UnidadMedida" width="200" alignment="Left" dataType="string" />
                  </Column>

                  <Column caption="Participantes" alignment="Center" >
                    <Column caption="Participantes" dataField="CantidadParticipantes" width="100" alignment="Right" dataType="number" />
                    <Column caption="Cargados" dataField="CantidadParticipantesCargados" width="100" alignment="Right" dataType="number" />
                    <Column caption="Sin Cargar" dataField="CantidadParticipantesSinCargar" width="100" alignment="Right" dataType="number" />
                  </Column>
                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}

        {this.state.loadingItems ? null : (
          <>
            {this.state.data && this.state.data.Integrantes && this.state.data.Integrantes.length > 0 ? (
              <>
                <LVGridDetalle
                  dataSource={this.state.data.Integrantes}
                  Titulo="Integrantes"
                >
                  <Column caption="Código" dataField="IdItem" width="80" alignment="Right" dataType="number" />

                  <Column caption="Cliente" alignment="Center" >
                    <Column caption="Código" dataField="IdCliente" width="120" alignment="Right" dataType="number" />
                    <Column caption="Nombre" dataField="Cliente" width="100%" minWidth={100} alignment="Left" dataType="string" />
                    <Column caption="D.N.I." dataField="DNI" width="100" alignment="Right" dataType="string" />
                    <Column caption="F.Nacimiento" dataField="FechaNacimiento" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                    <Column caption="Agasajado" dataField="Agasajado" width="100" alignment="Center" dataType="boolean" />
                  </Column>

                  <Column caption="Responsable" alignment="Center" >
                    <Column caption="Código" dataField="IdClienteResponsable" width="120" alignment="Right" dataType="number" />
                    <Column caption="Nombre" dataField="Responsable" width="200" alignment="Left" dataType="string" />
                    <Column caption="D.N.I." dataField="DNIResponsable" width="100" alignment="Right" dataType="string" />
                    <Column caption="F.Nacimiento" dataField="FechaNacimientoResponsable" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                  </Column>

                  <Column caption="Check In" dataField="FechaCheckIn" width="120" alignment="Right" dataType="date" format={'dd/MM/yyyy'} />
                  <Column caption="Color" dataField="Color" width="100" alignment="Left" dataType="string" />
                  <Column caption="Control" dataField="Control" width="100" alignment="Left" dataType="string" />

                </LVGridDetalle>
              </>
            ) : null}
          </>
        )}
      </React.Fragment>
    );
  }
}

export default VEN_Reservas_Detalle;
